export const PROMOCODE_SUCCESS = 'PROMOCODE_SUCCESS'
export const PROMOCODE_FAILURE = 'PROMOCODE_FAILURE'

export const promocodeData = (promocode) =>{
  return (dispatch, getState) => {
    dispatch({ type: PROMOCODE_SUCCESS,promocode });
  }
}
